import FormSelect from './FormSelect'
import { mapGetters } from 'vuex'
import _get from 'lodash/get'
import {
  getSections
} from '@/api'

export default {
  extends: FormSelect,
  props: {
    formValue: {
      type: Object,
      default: () => ({
        courseId: '',
        sectionType: '',
      }),
    },
    courseId: {
      type: String,
      default: '',
    },
    sectionType: {
      type: String,
      default: '',
    },
    config: {
      type: Object,
      default: () => ({}),
    },
  },
  data () {
    return {
      isOpen: false,
      isLoading: false,
      sections: [],
      sectionsLoaded: false,
    }
  },
  computed: {
    ...mapGetters([ 'getCourseOrEmpty', 'viewingTerm', 'school' ]),
    courseIdWithFallback () {
      return this.courseId || this.formValue.courseId
    },
    sectionTypeWithFallback () {
      return this.sectionType || this.formValue.sectionType
    },
    mergedConfig () { // or `configWithDefaults`
      return {
        multiple: false,
        searchable: true,
        optionFilter: null,
        options: [],
        optionField: 'sectionNumber',
        ...this.config,
      }
    },
    normalizedOptions () {
      const sections = this.mergedConfig.optionFilter ? this.sections.filter(el => {
        if (this.mergedConfig.optionFilter === 'sameSectionType') {
          return el.sectionType === this.sectionTypeWithFallback
        } else if (this.mergedConfig.optionFilter === 'differentSectionType') {
          return el.sectionType !== this.sectionTypeWithFallback
        }
      }) : this.sections
      const sectionOptions = sections.map(section =>
        _get(section, this.mergedConfig.optionField, '')).filter(Boolean).concat(this.mergedConfig.options || [])
      // ensuring section select options are unique
      return [ ...new Set(sectionOptions) ]
    },
  },
  watch: {
    isOpen: {
      async handler (val) {
        if (val && !this.sectionsLoaded) {
          if (!this.courseIdWithFallback) {
            this.sections = []
            return
          }
          const { year, semester } = this.viewingTerm || {}
          this.isLoading = true
          this.sections = await getSections({
            school: this.school,
            year,
            semester,
            courseId: this.courseIdWithFallback,
            returnArray: true,
          }) || []
          this.sectionsLoaded = true
          this.isLoading = false

        }
      },
    },
  },
  methods: {
    normalizedOptionLabel (val) {
      if (!val) return ''
      return val
    },
  },
}
